import React  from 'react'

import {FieldTListGroupHeader1Props} from "../../../render/list/group-1"

export default function FieldProto_TListGroupHeader1(props: FieldTListGroupHeader1Props) {
    return <div className="ui5-txt-default ui5-txt-red">{props.field.type}.tlistGroupHeader1</div>
}